
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2012_4356)"}},[_c('circle',{attrs:{"cx":"32","cy":"34.061","r":"19","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M32 .061c-17.645 0-32 14.355-32 32s14.355 32 32 32 32-14.355 32-32-14.355-32-32-32zM18.33 31.59l13.199-13.2a.665.665 0 01.942 0l13.2 13.2a.662.662 0 010 .943l-13.2 13.199a.666.666 0 01-.942 0l-13.2-13.2a.662.662 0 010-.942z","fill":"#1E1E1E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2012_4356"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .061)","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    